import { render } from "./TopMenu.vue?vue&type=template&id=636ec0b9&scoped=true"
const script = {}

import "./TopMenu.vue?vue&type=style&index=0&id=636ec0b9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636ec0b9"]])

export default __exports__